import React from 'react';
import bioMarkerData from '../../components/data/biomarker-environ.json';
import { countBioMarkers } from './countBiomarkers';
import { displayValue, displayTarget, displayChange } from './displayItems';

export const environCounts = countBioMarkers(bioMarkerData);

const BioMarkersEnviron = () => {
  const { totalMarkers, notMeasured, redFlags, greenCount, targetRange } = countBioMarkers(bioMarkerData);


  return (
    <div className="section" id="bio-markers">
      <h2>Bio Markers - Environmental Detoxification & Toxin Load</h2>
      <p>This system focuses on reducing toxic burden, enhancing detox pathways, and optimizing environmental resilience. It encompasses exocrine, lymphatic, and renal detoxification, ensuring effective removal of heavy metals, pollutants, and metabolic waste to minimize aging-related damage.</p>
      <div className="card-container">
        <h3>Environmental Markers: {totalMarkers}</h3>
        <h3>Not Measured: {notMeasured}</h3>
        <h3>Red Flags: <span style={{ color: "#ff3300" }}>{redFlags}</span></h3>
        <h3>Within Range: {targetRange}</h3>
        <h3>On Target: <span style={{ color: "#77b300" }}>{greenCount}</span></h3>
      </div>
      <div className="ai-prompt-table">
        <div className="table-header">
          <div className="table-title-bio">Marker</div>
          <div className="table-title-bio">Value</div>
          <div className="table-title-bio">Reference Target</div>
          <div className="table-title-bio">User Target</div>
          <div className="table-title-bio">Tested</div>
          <div className="table-title-bio-short">Change</div>
        </div>
        {bioMarkerData.map((bioMarker, index) => (
          <div className="table-row" key={index}>
            <div className="table-content">{bioMarker.marker}</div>
            <div className="table-content">{displayValue(bioMarker.value, bioMarker)}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'reference')}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'user')}</div>
            <div className="table-content">{bioMarker.tested.last}</div>
            <div className="table-content-short">{displayChange(bioMarker.change, bioMarker)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BioMarkersEnviron;